export default __webpack_public_path__ + "63eb7c4da93cd741f4ddccfd6ea11bd7.svg";